module.exports = __webpack_public_path__ + "img/001.ef3819a4.png";